export default __webpack_public_path__ + "static/media/0xff2382bd52efacef02cc895bcbfc4618608aa56f.a2a79feb.webp";